import * as React from "react"

export type ReportLine = {
    importance: number
    details: string
}

export type Reporter = () => ReportLine | string | Array<ReportLine | string>

let globalReporters = [] as Array<Reporter>

export function addReporter(r: Reporter) {
    globalReporters.push(r)
}

export function removeReporter(r: Reporter) {
    globalReporters = globalReporters.filter((k) => k != r)
}

export function clear() {
    globalReporters = []
}

export function summarize() {
    const lines = globalReporters.flatMap((r) => {
        const lines = r()
        if (Array.isArray(lines)) {
            return lines.map((x) => (typeof x === "string" ? { importance: 0, details: x } : x))
        } else if (typeof lines === "string") {
            return { importance: 0, details: lines }
        } else {
            return lines
        }
    })

    return lines
        .sort((a, b) => b.importance - a.importance)
        .map((x) => x.details)
        .join("\n\n---\n\n")
}

export function useDebug(cb: Reporter, dependencies: unknown[] = []) {
    React.useEffect(() => {
        addReporter(cb)
        return () => removeReporter(cb)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cb, ...dependencies])
}
